
import { useEffect } from 'react'
import { useAppDispatch } from 'shared/hooks'
import { setMainBarSettings } from 'store/applicationSlice'
import { setParentUrl } from 'store/applicationSlice'
import { PropertySpyResultItem } from 'features/propertySpyResult/propertySpyResultItem/ui/PropertySpyResultItem'

export const PropertySpyResultListPage = (): JSX.Element => {
    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(setMainBarSettings({
            back: {
                url: '/property'
            },
            title: 'Property Spy Results',
            showProfileButton: false
        }))
        dispatch(setParentUrl(`/property`))

        return () => {
            dispatch(setMainBarSettings(undefined))
            dispatch(setParentUrl(undefined))
        }
    })

    return (
        <PropertySpyResultItem
        />
    )
}